// This file is auto-generated during build
export const version: string = "20.2_2653";
